import React, { useState } from "react";
import {
  Box,
  ButtonBase,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { Check, ChevronDown } from "lucide-react";
import { useCurrencyStore } from "../store/useCurrencyStore";
import {
  CURRENCIES,
  CurrencyCode,
  SUPPORTED_CURRENCIES,
} from "../utils/currency";

const CurrencySelector: React.FC = () => {
  const currency = useCurrencyStore((s) => s.currency);
  const setCurrency = useCurrencyStore((s) => s.setCurrency);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);
  const active = CURRENCIES[currency];

  const handleSelect = (code: CurrencyCode) => {
    setCurrency(code);
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonBase
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-label="select currency"
        sx={{
          px: 1.25,
          py: 0.5,
          borderRadius: 999,
          border: "1px solid",
          borderColor: "divider",
          gap: 0.5,
          fontWeight: 600,
          fontSize: 13,
          color: "text.primary",
          "&:hover": { backgroundColor: "action.hover" },
        }}
      >
        <Typography component="span" fontWeight={600} fontSize={13}>
          {active.symbol} {active.code}
        </Typography>
        <ChevronDown size={14} />
      </ButtonBase>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { mt: 0.5, minWidth: 160 } } }}
      >
        {SUPPORTED_CURRENCIES.map((code) => {
          const cfg = CURRENCIES[code];
          const selected = code === currency;
          return (
            <MenuItem
              key={code}
              selected={selected}
              onClick={() => handleSelect(code)}
            >
              <Box sx={{ width: 20, mr: 1, fontWeight: 600 }}>
                {cfg.symbol}
              </Box>
              <ListItemText primary={cfg.label} />
              {selected && (
                <ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
                  <Check size={16} />
                </ListItemIcon>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default CurrencySelector;
